import React, { useState, useEffect } from "react";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { Col, Card, CardBody, Row, Label, Table } from "reactstrap";
import ManageOrder from "../ManageOrder";
import { AdminService } from "services/AdminService";
import { Setting } from "models/Setting";
import UpdateService from "./UpdateService";
import { useAuth } from "context/AuthProvider";
import { SettingsType } from "enum/SettingsType";

const ManageServices: React.FC = () => {
  const [settings, setSettings] = useState<Setting[]>([]);
  const [modalUpdate, setModalUpdate] = useState(false);
  const [isModified, setIsModified] = useState<boolean>(false);
  const [user] = useAuth();
  useEffect(() => {
    AdminService.getSettings().then(res => {
      if (res.success) {
        if (Array.isArray(res.data)) {
          setSettings(res.data);
        } else if (typeof res.data === "object") {
          setSettings([res.data]);
        }
      } else {
        setSettings([]);
      }
    })
      .catch(err => {
        console.error(err);
      })
  }, [isModified]);

  const handlePopup = () => {
    setModalUpdate(!modalUpdate)
  }
  const handleUpdateService = () => {
    handlePopup()
  }

  const getService = (settingsType: string) => {
    switch (settingsType) {
      case SettingsType.STANDARD:
        return 'Standard 8-6';
      case SettingsType.PRIORITY:
        return 'Priority 6-4';
      case SettingsType.RUSH:
        return 'Rush 4-2';
      case SettingsType.AFTER_HOURS:
        return 'After Hours (3PM–9PM)';
      default:
        return 'Economy 8hrs';
    }
  };

  //meta title
  document.title = "Manage Order";
  const className = "d-flex flex-row justify-content-center text-wrap"

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Manage Service" breadcrumbItem="Create" />
        <Row>
          <Col lg={12}>
            <ManageOrder />
            {user?.role === "super_admin" && (
              <Card>
                <CardBody>
                  <div className="d-inline-flex w-100 justify-content-between">
                    <Label className="fs-6 fw-bold">Manage Service</Label>
                    <div className="text-center">
                      <button className="btn btn-primary btn-sm px-3 py-2 mt-2 mb-2 rounded-1" onClick={handleUpdateService}>
                        Update Service
                      </button>
                    </div>
                  </div>
                  <div className="table-responsive react-table">
                    <table className="newTable">
                      <thead className="newThead">
                        <tr>
                          <th><div className={className}>Service</div></th>
                          <th><div className={className}>Base Price(Up to 5 Km)</div></th>
                          <th><div className={className}>Additional Km</div></th>
                          <th><div className={className}>After Km</div></th>
                          <th><div className={className}>Weight</div></th>
                          <th><div className={className}>Vehicle Type</div></th>
                          <th><div className={className}>Surge Price</div></th>
                        </tr>
                      </thead>
                      <tbody>
                        {settings.length === 0 ? (
                          <tr>
                            <td colSpan={7} className="text-center py-3">
                              No records found
                            </td>
                          </tr>
                        ) : (
                          settings.map((s, index) => (
                            <tr key={index}>
                              <td data-label="Service">
                                {s?.settingsType !== undefined && (
                                  <div>{getService(s?.settingsType)}</div>
                                )}
                              </td>
                              <td data-label="Base Price(Up to 5 Km)">
                                {s?.basePrice !== undefined && (
                                  <div>${s?.basePrice.toFixed(2)}</div>
                                )}
                              </td>
                              <td data-label="Additional Km">
                                {s?.pricePerAdditionalKM !== undefined && (
                                  <div>${s?.pricePerAdditionalKM.toFixed(2)}</div>
                                )}
                              </td>
                              <td data-label="After Km">
                                <div>
                                  {s?.pricePerAfterKM?.price !== undefined && s?.pricePerAfterKM?.price !== null && (
                                    <ul>
                                      <li>After {s?.pricePerAfterKM?.km} - ${s?.pricePerAfterKM?.price.toFixed(2)}</li>
                                    </ul>
                                  )}
                                </div>
                              </td>
                              <td data-label="Weight">
                                {s?.baseWeightPrice !== undefined && (
                                  <div>${s?.baseWeightPrice.toFixed(2)}</div>
                                )}</td>
                              <td data-label="Vehicle Type">
                                {s?.vehiclePrice !== undefined && (
                                  <div>
                                    {s?.vehiclePrice.map((val: any) => (
                                      <ul key={val.vehicle}>
                                        <li>{val.vehicle} - ${val.price.toFixed(2)}</li>
                                      </ul>
                                    ))}
                                  </div>
                                )}
                              </td>
                              <td data-label="Surge Price">
                                {s?.surgePrice !== undefined && s?.surgePrice !== null ? (
                                  <div>${s?.surgePrice.toFixed(2)}</div>
                                ) : (<div>$0</div>)}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>)}
          </Col>
        </Row>
      </div>
      <UpdateService
        isOpen={modalUpdate}
        handlePopup={handlePopup}
        isModified={isModified}
        setIsModified={setIsModified}
        settings={settings} />
    </div>
  )
}

export default ManageServices;